import { render, staticRenderFns } from "./ChoosePlatform.vue?vue&type=template&id=5737b85c&scoped=true"
import script from "./ChoosePlatform.vue?vue&type=script&lang=js"
export * from "./ChoosePlatform.vue?vue&type=script&lang=js"
import style0 from "./ChoosePlatform.vue?vue&type=style&index=0&id=5737b85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5737b85c",
  null
  
)

export default component.exports